export default (pages:string):string => `
-- Here are the list of pages currently showing in the dashboard --
${pages}
`;